import './StoreDetails.scss';
import { useSelector } from 'react-redux';
import { roundNumber } from '../utils/Utils';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';


const StoreDetails = (props) => {

    const selectedStore = useSelector(state => state.popupData.selectedStore);
    const physicalStores = useSelector(state => state.popupData.physicalStores);
    const { t } = useTranslation();

    const [showStoreHours, setShowStoreHours] = useState(false);

    const getDirections = () => {
        var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=';

        if (selectedStore) {
            directionsUrl += encodeURIComponent(selectedStore.addressLine[0].trim() 
                + ',' + selectedStore.city.trim() + ',' + selectedStore.stateOrProvinceName.trim() + ',' + selectedStore.postalCode.trim());

            window.open(directionsUrl,'_blank');
        }		
    };
    const StoreAddress = (props) => {
        if (props.show) {

            return <div className='container-fluid'>
                <div className='row m-bottom'>
                    <div className='col-12'>
                        <span className="store-name">{selectedStore.Description[0].displayStoreName.toLowerCase()} </span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-8'>
                        <span className="store-address">
                            {selectedStore.addressLine[0].toLowerCase()}
                            <br></br>
                            {selectedStore.city.toLowerCase()} , {selectedStore.stateOrProvinceName}
                        </span>
                    </div>
                    <div className='col-4 align-right'>
                        <span className="store-miles">{roundNumber(selectedStore.distance)}mi</span>
                        <div className="get-directions-container" onClick={getDirections}>
                            <div className="location-icon">
                                <svg>
                                    <use xlinkHref='#location-pin' />
                                </svg>
                            </div>
                            <a href="#" className="get-directions">{t('get-directions')}</a>
                        </div>
                    </div>
                </div>
 
            </div>
        }
        return null;
    }
    const StoreHours = (props) => {
        if (props.show) {
            return <div className='container-fluid'>
                <div className='row'>
                    <div className='col-11'>
                        <span className="store-hours">{t('store-hours')}</span>
                    </div>
                    <div className='col-1 align-right see-hours'>
                        {showStoreHours ? 
                            (<svg className="arrow-up" data-element-id='X_Pdp_FindStoreOverlay_OpeningHours' onClick={() => setShowStoreHours(!showStoreHours)}>
                                <use xlinkHref='#slim-arrow' />
                            </svg>) :
                             (<svg className="arrow-down" data-element-id='X_Pdp_FindStoreOverlay_OpeningHours' onClick={() => setShowStoreHours(!showStoreHours)}>
                                <use xlinkHref='#slim-arrow' />
                             </svg>)}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <GetStoreStatus></GetStoreStatus>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 see-hours-mobile'>
                        <span className="see-hours-mobile-text" data-element-id='X_Pdp_FindStoreOverlay_OpeningHours' onClick={() => setShowStoreHours(!showStoreHours)}>{t('see-hours')}</span>
                        {showStoreHours ? 
                            (<svg className="arrow-up" data-element-id='X_Pdp_FindStoreOverlay_OpeningHours' onClick={() => setShowStoreHours(!showStoreHours)}>
                                <use xlinkHref='#blue-arrow' />
                            </svg>) :
                                (<svg className="arrow-down"  data-element-id='X_Pdp_FindStoreOverlay_OpeningHours' onClick={() => setShowStoreHours(!showStoreHours)}>
                                <use xlinkHref='#blue-arrow ' />
                            </svg>)}                       
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {showStoreHours && <GetStoreOpeningHours></GetStoreOpeningHours>}
                    </div>
                </div>
            </div>
        }
        return null;
    }

    const GetStoreOpeningHours = () => {
        const storeAttributes = selectedStore.Attribute;
        let values;
        storeAttributes.forEach(element => {
            if (element.displayName === 'StoreHours') {
                values = element.displayValue.split(';');
            }
        });
        // filter store hours to show one value for week days
        const storeHours = values.filter((item, index) => index === 0 | index === 5 | index === 6).map((item, index) =>
            <div className="row">
                <div key={index} className='store-opening-hours-day M-top M-bottom'> {t('week-day-' + index)}</div>
                <div className='store-opening-hours'>{item}</div>
            </div>
        );
        return storeHours;
    }

    const GetStoreStatus = () => {
        const storeAttributes = selectedStore.Attribute;
        let storeStatus;
        storeAttributes.forEach(element => {
            if (element.name === 'StoreStatus') {
                storeStatus = element.value;
            }
        });
        let values;
        storeAttributes.forEach(element => {
            if (element.displayName === 'StoreHours') {
                values = element.displayValue.split(';');
            }
        });
        var date = new Date();
        var indexOfToday = date.getDay() === 0 ? 6 : date.getDay()-1;
        // filter store hours to show one value for week days
        let storeHours = null;
        let openToday = null;
        try {
            if (values[indexOfToday].trim() == 'closed' || values[indexOfToday] == '' ||  values[indexOfToday] == undefined){
                openToday = false
            }else{
                storeHours = values.filter((item, index) => index === indexOfToday).map((item, index) => item.split('-')[1].trim());
                openToday = true
            }
        }catch{
            openToday = false
            console.log("Error StoreHours value");
        }
       
        return <div className='container-fluid'>
            <div className='row'>
                <div className={( openToday ? ` green-text` : ` red-text`)}>
                    {openToday ? t('store-open') : t('store-closed')}
                </div>
                {openToday && (
                    <div className="store-closed-hours-text">{t('store-closed-hours')}<span className="store-closed-hours">{storeHours}</span></div>
                )}
            </div>
        </div>

    }

    const StorePhoneNumber = (props) => {
        if (props.show) {
            return <div className='container-fluid'>
                <div className='row'>
                    <div className='phone-icon'>
                        <svg>
                            <use xlinkHref='#phone' />
                        </svg>
                    </div>
                    <div className='col-11 telephone-number-container'>
                        <a className='telephone-number' rel='noreferrer' href={'tel:' + selectedStore.telephone1} target='_blank'>{selectedStore.telephone1}</a>
                    </div>
                </div>

            </div>
        }
        return null;
    }

    const tryInStoreClick = () => {
        window.location = window.location.origin + '/BookingDisplayView?storeNumber=' + selectedStore.storeName + '&selectedSku=' + props.config.data.frame.upc + '&appType=SHOP';
    }

    const GetTryInStore = (props) => {
        var showButton = false; //Forzatura per nascondere il button
        if (!!showButton && props.show) {
            const storeAvailableBTE = selectedStore.x_availableBTE;

            var frameFound = false;
            var frameAvariableStores = physicalStores.filter((store, index) => store.x_storeFound === "true");
            if (frameAvariableStores.length !== 0){
                frameFound = true
            }
            if (storeAvailableBTE && !!frameFound) {
                return (
                    <div className="store-details-bottom">
                        <div className="row">
                            <span className="store-details-description col-10">{t('try-description')}</span>
                        </div>
                        <div className="row store-details-button">
                            <button className="button-medium-blue-fill" data-element-id='X_Pdp_FindStoreOverlay_Try' onClick={() => {tryInStoreClick()}}>{t('try-in-store')}</button>
                        </div>
                    </div>
                )
            }
        }
        return null;
    }

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <StoreAddress show={selectedStore}></StoreAddress>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div hidden={!selectedStore} className='line'></div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <StoreHours show={selectedStore}></StoreHours>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div hidden={!selectedStore} className='line'></div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <StorePhoneNumber show={selectedStore}></StorePhoneNumber>
                </div>
            </div>
            <GetTryInStore show={selectedStore}></GetTryInStore>
        </div>
    )
}


export default StoreDetails


